import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ReportsService } from '../../../services/reports.service';
import { ReportModel, SelectedFile, SelectedReports } from '../../../models/reports';
import { PickerValue } from '../../../components/generic-picker/generic-picker.component';
import { GetQuarter, GetQuarterEnd, GetQuarterStart } from '../../../utils/quarter-utils';
import { downloadFile } from '../../../tools/reports-tools';

@Component({
  selector: 'lib-quarterly-reports',
  templateUrl: './quarterly-reports.component.html',
  styleUrls: ['./quarterly-reports.component.css'],
  standalone: false
})
export class QuarterlyReportsComponent implements OnInit {
  @Input()
  public clientCode: string;
  @Output()
  public downloadClicked = new EventEmitter<SelectedReports | null>();
  public quarterForm: UntypedFormGroup;
  public loadingReports = false;
  public reports: ReportModel[] = [];

  public minimumValue: PickerValue;
  public maximumValue: PickerValue;

  public chosen: SelectedReports | null = null;

  constructor(
    private fb: UntypedFormBuilder,
    private service: ReportsService
  ) {}

  ngOnInit(): void {
    this.service.getQuarterlyReportRange(this.clientCode).subscribe(x => {
      const now = new Date();
      const qtr = GetQuarter(now);
      this.minimumValue = {
        year: x.MinYear ?? now.getFullYear(),
        value: x.MinQuarter ?? qtr
      };
      this.maximumValue = {
        year: x.MaxYear ?? now.getFullYear(),
        value: x.MaxQuarter ?? qtr
      };

      const chosenQuarter = {
        year: this.maximumValue.year,
        quarter: this.maximumValue.value
      };
      this.quarterForm = this.fb.group({
        chosenQuarter: [chosenQuarter]
      });
      this.quarterForm.get('chosenQuarter').valueChanges.subscribe(val => this.quarterChanged(val));
      this.loadReports(chosenQuarter);
    });
  }

  loadReports(chosen: { year: number; quarter: number }) {
    this.loadingReports = true;
    this.service
      .getQuarterlyReports(this.clientCode, chosen.year, chosen.quarter)
      .subscribe(result => {
        this.reports = result;
        this.loadingReports = false;
      });
  }

  public selectionChanged(filenames: SelectedFile[]) {
    if (filenames == null || filenames.length === 0) {
      this.chosen = null;
    } else {
      this.chosen = {
        year: 0,
        sequenceNumber: 0,
        filenames
      };
    }
  }

  public download() {
    let mimeType: string = '';
    if (this.chosen.filenames.length > 1) {
      mimeType = 'application/zip';
    } else {
      mimeType = this.chosen.filenames[0].mimeType;
    }
    const chosenQuarter = this.quarterForm.get('chosenQuarter').value;
    this.service
      .downloadQuarterlyReport(
        this.clientCode,
        this.chosen.filenames.map(x => x.file),
        mimeType,
        chosenQuarter.year,
        chosenQuarter.quarter
      )
      .subscribe(x => {
        const header = x.headers.get('X-Download-Filename');
        const name: string = JSON.parse(header).name;
        downloadFile(x.body, name);
      });
  }

  private quarterChanged(val) {
    this.loadReports(val);
  }
}
